"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFunnelControlDisabledRedirection = void 0;

var _utilities = _interopRequireDefault(require("../../../utilities"));

var _constant = require("../constant");

var _utils = require("../utils");

var _utilities2 = require("../ButtonWrapper/utilities");

var otaRedirection = function otaRedirection(originObj, destObj, dates, type, pax, promo, environment, locale, currency, agentId, showTravelClass, showFswCabinClass, travelClass) {
  var otaRedirectionUrl = '';
  var cabinClass = showTravelClass && showFswCabinClass ? travelClass : null;
  otaRedirectionUrl = (0, _utils.getRedirectionURL)(originObj, destObj, dates, type, pax, promo, environment, locale, currency, agentId, cabinClass);

  if (_utilities.default.isLocalEnvironment()) {
    otaRedirectionUrl = "".concat(_constant.LOCAL_HOST_URL, "?").concat((0, _utils.getListingAppQueryParameter)(originObj, destObj, dates, type, pax, promo, locale, currency, cabinClass, agentId));
  }

  return new Promise(function (resolve) {
    resolve(otaRedirectionUrl);
  });
};

var airAsiaIndiaRedirection = function airAsiaIndiaRedirection(origin, destination, tripDates, tripType, passengers, promoCode, currency, environment, aaiRedirectionFlag) {
  if (aaiRedirectionFlag === 'true') {
    var aaiRedirectUrl = (0, _utils.getAAIRedirectionURL)(origin, destination, tripDates, tripType, passengers, promoCode, currency, environment);
    return new Promise(function (resolve) {
      resolve(aaiRedirectUrl);
    });
  }

  return otaRedirection(origin, destination, tripDates, tripType, passengers, promoCode);
};

var airAsiaRedirection = function airAsiaRedirection(originObj, destObj, dates, type, pax, promo, locale, currency, environment, isMobile, baseCurrency, isLogin, bigLoyaltyToggleValue, endpointConfig, enableDataVisor, isEdit) {
  var channelId = isMobile ? _constant.CHANNEL_HASH.mobileWeb : _constant.CHANNEL_HASH.web;
  var selectPage = 'select';
  var deepLinkData = (0, _utilities2.constructDeeplinkData)(baseCurrency, isLogin, bigLoyaltyToggleValue, type, locale, originObj, destObj, dates, pax, currency, promo);
  var headers = {
    Accept: 'text/html',
    'Content-Type': 'application/json',
    channel_hash: channelId,
    page: selectPage,
    exclude_domain: deepLinkData.exclude_domain ? 'true' : 'false'
  };
  (0, _utilities2.callDataVisorEndpoint)(enableDataVisor, originObj, destObj, type, dates, pax, isEdit, endpointConfig, environment);
  var deepLinkUrl = (0, _utils.formatEndpointURL)((0, _utils.getEndpointURL)(endpointConfig, 'searchDeepLink'), environment);
  return (0, _utilities2.fetchData)(deepLinkUrl, headers, deepLinkData);
};

var getFunnelControlDisabledRedirection = function getFunnelControlDisabledRedirection(operatingAirline, origin, destination, tripDates, tripType, passengers, promoCode, customSearchHandler, goToSnapToggle, bigLoyaltyToggleValue, environment, locale, currency, agentId, showTravelClass, showFswCabinClass, travelClass, aaiRedirectionFlag, isMobile, baseCurrency, isLogin, endpointConfig, enableDataVisor, isEdit) {
  switch (operatingAirline) {
    case _constant.AIRLINES.FLYBEYOND:
      return otaRedirection(origin, destination, tripDates, tripType, passengers, promoCode, environment, locale, currency, agentId, showTravelClass, showFswCabinClass, travelClass);

    case _constant.AIRLINES.AAB:
      if (customSearchHandler) {
        customSearchHandler({
          origin: origin,
          destination: destination,
          tripDates: tripDates,
          tripType: tripType,
          passengers: passengers,
          promoCode: promoCode,
          goToSnapToggle: goToSnapToggle,
          bigLoyaltyToggleValue: bigLoyaltyToggleValue
        });
        return Promise.resolve({
          skipRedirect: true
        });
      }

      return airAsiaRedirection(origin, destination, tripDates, tripType, passengers, promoCode, locale, currency, environment, isMobile, baseCurrency, isLogin, bigLoyaltyToggleValue, endpointConfig, enableDataVisor, isEdit);

    case _constant.AIRLINES.AAI:
      if (customSearchHandler) {
        customSearchHandler({
          origin: origin,
          destination: destination,
          tripDates: tripDates,
          tripType: tripType,
          passengers: passengers,
          promoCode: promoCode,
          goToSnapToggle: goToSnapToggle,
          bigLoyaltyToggleValue: bigLoyaltyToggleValue
        });
        return Promise.resolve({
          skipRedirect: true
        });
      }

      return airAsiaIndiaRedirection(origin, destination, tripDates, tripType, passengers, promoCode, currency, environment, aaiRedirectionFlag);

    default:
      return Promise.reject(new Error('Operating airline not found'));
  }
};

exports.getFunnelControlDisabledRedirection = getFunnelControlDisabledRedirection;